import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select'
import { useShippingCarriers } from '@/hooks/use-shipping-carriers-query'
import { m } from '@/lib/paraglide/messages'

interface ShippingCarrierSelectProps {
    id: string
    value: string
    onValueChange: (value: string) => void
    className?: string
    disabled?: boolean
}

export function ShippingCarrierSelect({
    id,
    value,
    onValueChange,
    className,
    disabled,
}: ShippingCarrierSelectProps) {
    const { data, isLoading } = useShippingCarriers({
        is_active: true,
        per_page: 100,
    })
    const carriers = data?.data ?? []

    return (
        <Select
            value={value || undefined}
            onValueChange={onValueChange}
            disabled={disabled || isLoading || carriers.length === 0}
        >
            <SelectTrigger id={id} className={className}>
                <SelectValue
                    placeholder={m.shipping_carrier_select_placeholder()}
                />
            </SelectTrigger>
            <SelectContent>
                {carriers.map((carrier) => (
                    <SelectItem key={carrier.id} value={carrier.id}>
                        {carrier.name}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    )
}
